export const themes = ['neon-tech', 'aurora'] as const;

export type ThemeName = (typeof themes)[number];

export function applyTheme(theme: ThemeName) {
  document.documentElement.dataset.theme = theme;
}
